import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const HamburgerMenuButton = ({
  id,
  open,
  onClick,
  className,
}: {
  id?: string;
  open: boolean;
  onClick: () => void;
  className?: string;
}) => {
  const spanClass = cn(
    "absolute inline-block h-[3px] w-1/2 rounded-md bg-monotone-9 transition-all duration-200",
  );

  return (
    <Button
      id={id}
      variant="ghost"
      data-opened={open}
      className={cn("group relative h-10 w-10", className)}
      onClick={onClick}
    >
      <span
        className={cn(
          spanClass,
          "top-[9px]",
          "group-data-[opened=true]:top-[12px]",
          "group-data-[opened=true]:translate-y-1.5 group-data-[opened=true]:-rotate-45",
        )}
      />
      <span
        className={cn(
          spanClass,
          "top-[18px]",
          "group-data-[opened=true]:opacity-0",
        )}
      />
      <span
        className={cn(
          spanClass,
          "top-[27px]",
          "group-data-[opened=true]:top-[24px]",
          "group-data-[opened=true]:-translate-y-1.5 group-data-[opened=true]:rotate-45",
        )}
      />
    </Button>
  );
};
